import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { makeStyles } from 'tss-react/mui';
import MuiSwipeableDrawer from '@mui/material/SwipeableDrawer';
const useStyles = makeStyles()(() => ({
    fullWidth: {
        width: '100%',
    },
}));
const SwipeableDrawer = React.forwardRef(({ fullWidth, classes, ...rest }, ref) => {
    const { classes: customClasses, cx } = useStyles();
    return (_jsx(MuiSwipeableDrawer, { ...rest, ref: ref, classes: fullWidth
            ? {
                ...classes,
                paper: cx(classes?.paper, customClasses.fullWidth),
            }
            : classes }));
});
export { SwipeableDrawer };
